import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';
import { EyesPosition } from 'src/models/Session.model';

import getGradingResult from 'src/utils/getGradingResult';

interface RetakeActionButtonsProps {
  handleRetake: (position: EyesPosition) => void;
  handleCloseAnalyzingProgressModal: () => void;
}

const RetakeActionButtons = ({
  handleRetake,
  handleCloseAnalyzingProgressModal,
}: RetakeActionButtonsProps) => {
  const { session } = useRemoteBoundStore();

  const { isLeftEyeGradable, isRightEyeGradable } = getGradingResult(session);

  const isBothEyeUngradable = !isLeftEyeGradable && !isRightEyeGradable;

  const { t } = useTranslation(I18NextNS.PAGES, { keyPrefix: 'newExam' });

  return (
    <>
      {session.graded && isBothEyeUngradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.BOTH);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {t('retake')}
        </Button>
      )}
      {session.graded && !isBothEyeUngradable && !isLeftEyeGradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.LEFT);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {t('retakeLeftEye')}
        </Button>
      )}

      {session.graded && !isBothEyeUngradable && !isRightEyeGradable && (
        <Button
          variant="primary-100"
          onClick={() => {
            handleRetake(EyesPosition.RIGHT);
            handleCloseAnalyzingProgressModal();
          }}
          disabled={!session.graded}
        >
          {t('retakeRightEye')}
        </Button>
      )}
    </>
  );
};

export default RetakeActionButtons;
